import React from 'react';
import cn from 'classnames';
import styles from './styles';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(styles);

const TextInput = ({ error, label, type = 'text', disabled = false, ...inputProps }) => {
  const classes = useStyles();

  const InputElement = type === 'textarea' ? 'textarea' : 'input';

  return (
    <div className={cn(classes.inputContainer)}>
      {label && (
        <p
          style={{ marginBottom: 5, fontWeight: 400 }}
          className={cn(
            classes.inputLabel,
            // disabledOnEdit && mode === 'EDIT' && classes.disabledText,
            // error && classes.textLabelError,
          )}
        >
          {label}
          {/* : {!!error && error} */}
        </p>
      )}
      <InputElement
        type={type}
        className={cn(
          classes.input,
          classes.textInput,
          // !!error && classes.textInputError,
          disabled && classes.disabledInput,
        )}
        readOnly={disabled}
        {...inputProps}
      />
    </div>
  );
};

export default TextInput;
